import React from 'react';
import { estaLogado } from './helper';
import { getUrlVars } from '../shared/helper/utilitarioUrl';
import history from '../history';
import LoginImpl from "./LoginImpl";
import { abrirGovbr } from './actions';

class Login extends React.Component {
    componentWillMount() {
        let page = getUrlVars()['page'];
        if(estaLogado()) {
            history.replace(page ? page : '/');
        } else if (localStorage.getItem('auth') === 'govbr' && page) { // Helô
            abrirGovbr();
        }
    }

    render() {
        let criarContaUrl = 'https://acesso.gov.br/acesso/#/primeiro-acesso?clientDetails=eyJjbGllbnRVcmkiOiJodHRwczpcL1wvbWV1Lmluc3MuZ292LmJyXC8iLCJjbGllbnROYW1lIjoiTWV1IElOU1MiLCJjbGllbnRWZXJpZmllZFVzZXIiOmZhbHNlfQ%3D%3D';
        let esqueciSenhaUrl = 'https://acesso.gov.br/acesso/#/recuperarSenha?clientDetails=eyJjbGllbnRVcmkiOiJodHRwczpcL1wvbWV1Lmluc3MuZ292LmJyXC8iLCJjbGllbnROYW1lIjoiTWV1IElOU1MiLCJjbGllbnRWZXJpZmllZFVzZXIiOmZhbHNlfQ%3D%3D';
        let inscreverInssUrl = 'https://cnisnet.inss.gov.br/cnisinternet/faces/pages/perfil.xhtml;jsessionid=mwD7dRHMx7GLdxxB7x67fdNtttk4r9X0rtstktSdd1vLMhpbz41L!1762142665';
        let inscreverCnisObj = {"externalLink": "Inscrever no INSS", "url": inscreverInssUrl };

        return (
           <div className='govbr'>
            <LoginImpl 
                criarContaUrl={criarContaUrl}
                esqueciSenhaUrl={esqueciSenhaUrl}
                inscriverInssUrl={inscreverInssUrl}
                increverCnisObj={inscreverCnisObj}
                abrirGovbr={abrirGovbr} />
            </div>
        )
    }
}

export default Login;